import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, ViewChild, OnDestroy } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { Form, FormControl, FormGroup, NgForm } from '@angular/forms';
import { GlobalValidators } from '../../../utils/validators';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss'],
})
export class RequestComponent implements OnInit, OnDestroy {
  activeTab = 'tab2';
  requestList;
  @Input() crmCode;
  reportType = {
    BALANCE_CONFIRMATION: 'Balance Confirmation',
    BANK_ACCOUNT_ADDITION: 'Bank Account Addition',
    ACCOUNT_STATEMENT: 'Account Statement',
    CORRESPONDENCE_ADDRESS_CHANGE: 'Correspondence Address Change',
    SIGNATURE_UPLOAD: 'Signature Upload',
    BANK_ACCOUNT_CHANGE: 'Bank Account Change',
  };

  addressChangeForm = new FormGroup({
    currentAddress: new FormControl('', GlobalValidators.required),
    newAddress: new FormControl('', GlobalValidators.required),
    attachment: new FormControl('', GlobalValidators.required),
  });

  signatureUpload = new FormGroup({
    attachment: new FormControl('', GlobalValidators.required),
  });

  bankDetailChange = new FormGroup({
    currentBankName: new FormControl('', GlobalValidators.required),
    currentAccountNo: new FormControl('', GlobalValidators.required),
    currentBranchName: new FormControl('', GlobalValidators.required),
    currentRoutingNo: new FormControl('', GlobalValidators.required),
    newBankName: new FormControl('', GlobalValidators.required),
    newAccountNo: new FormControl('', GlobalValidators.required),
    newBranchName: new FormControl('', GlobalValidators.required),
    newRoutingNo: new FormControl('', GlobalValidators.required),
  });

  uploadError;
  submitInProgress = false;
  successMsg = false;
  submissionErrors = '';
  @ViewChild('addressForm') addressForm: NgForm;
  @ViewChild('signatureForm') signatureForm: NgForm;
  @ViewChild('bankForm') bankForm: NgForm;

  constructor(private accountService: AccountService, private cdRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.getRequestTypes();
  }

  navigateTab(tab) {
    this.activeTab = tab;
    if (tab === 'tab1') {
      this.getRequestTypes();
    }
    if (tab === 'tab2') {
      this.resetAddressChangeForm();
    }
    if (tab === 'tab3') {
      this.resetSignatureUploadForm();
    }
  }

  resetAddressChangeForm() {
    this.addressChangeForm.reset();
    this.addressChangeForm.markAsUntouched();
    this.submitInProgress = false;
    this.successMsg = false;
    this.uploadError = undefined;
    this.submissionErrors = '';
  }

  resetSignatureUploadForm() {
    this.signatureUpload.reset();
    this.signatureUpload.markAsUntouched();
    this.submitInProgress = false;
    this.successMsg = false;
    this.uploadError = undefined;
    this.submissionErrors = '';
  }

  resetBankChangeForm() {
    this.bankDetailChange.reset();
    this.bankDetailChange.markAsUntouched();
    this.submitInProgress = false;
    this.successMsg = false;
    this.uploadError = undefined;
    this.submissionErrors = '';
  }

  async getRequestTypes() {
    try {
      this.requestList = await this.accountService.getClientRequest();
      this.requestList = this.requestList.sort((a, b) => b.id - a.id);
      if (this.requestList && this.requestList.length > 0) {
        this.activeTab = 'tab1';
      }
      this.cdRef.detectChanges();
    } catch (e) {}
  }

  setUploadError(error) {
    this.uploadError = error;
    setTimeout(() => {
      this.uploadError = undefined;
    }, 2400);
  }

  async changeAddress(form) {
    if (form.invalid) {
      return;
    }
    try {
      this.submitInProgress = true;
      let data = await this.accountService.submitClientRequest('CORRESPONDENCE_ADDRESS_CHANGE', 'INDIVIDUAL', form.value);
      this.successMsg = true;
      this.submitInProgress = false;
      setTimeout(() => {
        this.addressForm.resetForm();
        this.resetAddressChangeForm();
      }, 2400);
    } catch (e) {
      this.submitInProgress = false;
      this.submissionErrors = e.error.message;
    }
  }

  async uploadSignature(form) {
    if (form.invalid) {
      return;
    }
    try {
      this.submitInProgress = true;
      let data = await this.accountService.submitClientRequest('SIGNATURE_UPLOAD', 'INDIVIDUAL', form.value);
      this.successMsg = true;
      this.submitInProgress = false;
      setTimeout(() => {
        this.signatureForm.resetForm();
        this.resetSignatureUploadForm();
      }, 2400);
    } catch (e) {
      this.submitInProgress = false;
      this.submissionErrors = e.error.message;
    }
  }

  async submitBankDetails(form?) {
    if (form.invalid) {
      return;
    }
    try {
      this.submitInProgress = true;
      let data = await this.accountService.submitClientRequest('BANK_ACCOUNT_CHANGE', 'INDIVIDUAL', form.value);
      this.successMsg = true;
      this.submitInProgress = false;
      setTimeout(() => {
        this.bankForm.resetForm();
        this.resetBankChangeForm();
      }, 2400);
    } catch (e) {
      this.submitInProgress = false;
      this.submissionErrors = e.error.message;
    }
  }

  ngOnDestroy() {
    this.accountService.emitPendingHistory('');
  }
}
